<template>
  <div class="payment-item-number-box">
    <span v-if="!isEditPaymentNumber" class="payment-item-number">
      {{ item.payment_number }}
    </span>
    <el-input
      v-if="isEditPaymentNumber"
      v-model="itemInner.payment_number"
      suffix-icon="el-icon-edit"
      size="mini"
      class="payment-item-number-input"
    />
    <el-button
      class="payment-item-number--button"
      :type="isEditPaymentNumber ? 'success' : 'primary'"
      :icon="isEditPaymentNumber ? 'el-icon-check' : 'el-icon-edit'"
      size="small"
      circle
      plain
      @click="paymentNumberHandler(itemInner)"
    />
  </div>
</template>

<script>
export default {
  name: 'BidsPaymentModalItem',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      itemInner: { ...this.item },
      isEditPaymentNumber: false,
      data: {},
    }
  },
  created() {
    this.data = this.item
  },
  methods: {
    async paymentNumberHandler(paymentItem) {
      if (this.isEditPaymentNumber) {
        await this.$store.dispatch('payments/UPDATE_PAYMENT', paymentItem)
      }

      this.isEditPaymentNumber = !this.isEditPaymentNumber
    },
  },
}
</script>

<style lang="sass">
.payment-item-number
  margin-right: 10px

.payment-item-number-input.el-input
  width: 60%
  margin-right: 10px

.payment-item-number-box
  display: flex
  justify-content: space-between
  align-items: center

.payment-item-number--button.el-button
  margin-right: 20%
</style>
